module.exports = __webpack_public_path__ + "static/media/hof.85f6686f.jpg";